/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class MenuConfiguration extends DaoModel {
  constructor(guid, useButtons, useShoppingCart, useProductRecommendations,
    useInitialRecommendations, displayCurrency,
    recommendationTextAlt1, recommendationTextAlt2, recommendationTextAlt3,
    setPricesJustifiedToRight, setBorderToMenu, setBordersToSubsections, defaultAllergensStatus,
    menu, useTextOutline, useHyphenText, displayIconPopup, displayProductDescription,
    displayBranding, displaySocialMedia, displaySocialMediaIcons, displayProductTags,
    displayProductTagsUsingIcons, useFlagsMenuLanguageSelector, useIconInProductFeatures,
    useSeparatorOfProduct, useBannerRecommendation, brandingImage,
    footerTextAlt1, footerTextAlt2, footerTextAlt3, shopTextAlt1, shopTextAlt2, shopTextAlt3,
    shopTextProductPopupQtyAlt1, shopTextProductPopupQtyAlt2, shopTextProductPopupQtyAlt3,
    shopTextProductPopupCommentAlt1, shopTextProductPopupCommentAlt2, shopTextProductPopupCommentAlt3,
    shopTextProductPopupSpecialTextCommentAlt1, shopTextProductPopupSpecialTextCommentAlt2,
    shopTextProductPopupSpecialTextCommentAlt3, shopTextProductPopupAddBtnAlt1, shopTextProductPopupAddBtnAlt2,
    shopTextProductPopupAddBtnAlt3, shopCartTextTotalAlt1, shopCartTextTotalAlt2, shopCartTextTotalAlt3,
    shopCartTextOrderBtnAlt1, shopCartTextOrderBtnAlt2, shopCartTextOrderBtnAlt3,
    shopCartTextCommentBtnSaveAlt1, shopCartTextCommentBtnSaveAlt2, shopCartTextCommentBtnSaveAlt3,
    shopCartTitleModalAlt1, shopCartTitleModalAlt2, shopCartTitleModalAlt3, shopCartSuccessMessageOrderAlt1,
    shopCartSuccessMessageOrderAlt2, shopCartSuccessMessageOrderAlt3, shopCartErrorMessageOrderAlt1,
    shopCartErrorMessageOrderAlt2, shopCartErrorMessageOrderAlt3) {
    super(guid);
    this.useButtons = useButtons || false;
    this.useShoppingCart = useShoppingCart || false;
    this.useProductRecommendations = useProductRecommendations || false;
    this.useInitialRecommendations = useInitialRecommendations || false;
    this.displayCurrency = displayCurrency || false;
    this.recommendationTextAlt1 = recommendationTextAlt1 || '';
    this.recommendationTextAlt2 = recommendationTextAlt2 || '';
    this.recommendationTextAlt3 = recommendationTextAlt3 || '';
    this.setPricesJustifiedToRight = setPricesJustifiedToRight || false;
    this.setBorderToMenu = setBorderToMenu || false;
    this.setBordersToSubsections = setBordersToSubsections || false;
    this.defaultAllergensStatus = defaultAllergensStatus || false;
    this.menu = menu;
    this.useTextOutline = useTextOutline || false;
    this.useHyphenText = useHyphenText || false;
    this.displayIconPopup = displayIconPopup || false;
    this.displayProductDescription = displayProductDescription || false;
    this.displayBranding = displayBranding || false;
    this.displaySocialMedia = displaySocialMedia || false;
    this.displaySocialMediaIcons = displaySocialMediaIcons || false;
    this.displayProductTags = displayProductTags || false;
    this.displayProductTagsUsingIcons = displayProductTagsUsingIcons || false;
    this.useFlagsMenuLanguageSelector = useFlagsMenuLanguageSelector || false;
    this.useIconInProductFeatures = useIconInProductFeatures;
    this.useSeparatorOfProduct = useSeparatorOfProduct || false;
    this.useBannerRecommendation = useBannerRecommendation || false;
    this.brandingImage = brandingImage || undefined;
    this.footerTextAlt1 = footerTextAlt1 || '';
    this.footerTextAlt2 = footerTextAlt2 || '';
    this.footerTextAlt3 = footerTextAlt3 || '';
    this.shopTextAlt1 = shopTextAlt1;
    this.shopTextAlt2 = shopTextAlt2;
    this.shopTextAlt3 = shopTextAlt3;
    this.shopTextProductPopupQtyAlt1 = shopTextProductPopupQtyAlt1;
    this.shopTextProductPopupQtyAlt2 = shopTextProductPopupQtyAlt2;
    this.shopTextProductPopupQtyAlt3 = shopTextProductPopupQtyAlt3;
    this.shopTextProductPopupCommentAlt1 = shopTextProductPopupCommentAlt1;
    this.shopTextProductPopupCommentAlt2 = shopTextProductPopupCommentAlt2;
    this.shopTextProductPopupCommentAlt3 = shopTextProductPopupCommentAlt3;
    this.shopTextProductPopupSpecialTextCommentAlt1 = shopTextProductPopupSpecialTextCommentAlt1;
    this.shopTextProductPopupSpecialTextCommentAlt2 = shopTextProductPopupSpecialTextCommentAlt2;
    this.shopTextProductPopupSpecialTextCommentAlt3 = shopTextProductPopupSpecialTextCommentAlt3;
    this.shopTextProductPopupAddBtnAlt1 = shopTextProductPopupAddBtnAlt1;
    this.shopTextProductPopupAddBtnAlt2 = shopTextProductPopupAddBtnAlt2;
    this.shopTextProductPopupAddBtnAlt3 = shopTextProductPopupAddBtnAlt3;
    this.shopCartTextTotalAlt1 = shopCartTextTotalAlt1;
    this.shopCartTextTotalAlt2 = shopCartTextTotalAlt2;
    this.shopCartTextTotalAlt3 = shopCartTextTotalAlt3;
    this.shopCartTextOrderBtnAlt1 = shopCartTextOrderBtnAlt1;
    this.shopCartTextOrderBtnAlt2 = shopCartTextOrderBtnAlt2;
    this.shopCartTextOrderBtnAlt3 = shopCartTextOrderBtnAlt3;
    this.shopCartTextCommentBtnSaveAlt1 = shopCartTextCommentBtnSaveAlt1;
    this.shopCartTextCommentBtnSaveAlt2 = shopCartTextCommentBtnSaveAlt2;
    this.shopCartTextCommentBtnSaveAlt3 = shopCartTextCommentBtnSaveAlt3;
    this.shopCartTitleModalAlt1 = shopCartTitleModalAlt1;
    this.shopCartTitleModalAlt2 = shopCartTitleModalAlt2;
    this.shopCartTitleModalAlt3 = shopCartTitleModalAlt3;
    this.shopCartSuccessMessageOrderAlt1 = shopCartSuccessMessageOrderAlt1;
    this.shopCartSuccessMessageOrderAlt2 = shopCartSuccessMessageOrderAlt2;
    this.shopCartSuccessMessageOrderAlt3 = shopCartSuccessMessageOrderAlt3;
    this.shopCartErrorMessageOrderAlt1 = shopCartErrorMessageOrderAlt1;
    this.shopCartErrorMessageOrderAlt2 = shopCartErrorMessageOrderAlt2;
    this.shopCartErrorMessageOrderAlt3 = shopCartErrorMessageOrderAlt3;
  }

  static toInstance(props = {}) {
    return new MenuConfiguration(props.guid, props.use_buttons, props.use_shopping_cart,
      props.use_product_recommendations, props.use_initial_recommendations, props.display_currency,
      props.recommendation_text_alt1, props.recommendation_text_alt2, props.recommendation_text_alt3,
      props.set_prices_justified_to_right, props.set_border_to_menu,
      props.set_borders_to_subsections, props.default_allergens_status,
      props.menu, props.use_text_outline, props.use_hyphen_text, props.display_icon_popup,
      props.display_product_description, props.display_branding, props.display_social_media,
      props.display_social_media_icons, props.display_product_tags,
      props.display_product_tags_using_icons, props.use_flags_menu_language_selector,
      props.use_icon_in_product_features, props.use_separator_of_product, props.use_banner_recommendation,
      props.branding_image, props.footer_text_alt1, props.footer_text_alt2, props.footer_text_alt3,
      props.shop_text_alt1, props.shop_text_alt2, props.shop_text_alt3, props.shop_text_product_popup_qty_alt1,
      props.shop_text_product_popup_qty_alt2, props.shop_text_product_popup_qty_alt3,
      props.shop_text_product_popup_comment_alt1, props.shop_text_product_popup_comment_alt2,
      props.shop_text_product_popup_comment_alt3, props.shop_text_product_popup_special_text_comment_alt1,
      props.shop_text_product_popup_special_text_comment_alt2, props.shop_text_product_popup_special_text_comment_alt3,
      props.shop_text_product_popup_add_btn_alt1, props.shop_text_product_popup_add_btn_alt2,
      props.shop_text_product_popup_add_btn_alt3, props.shop_cart_text_total_alt1, props.shop_cart_text_total_alt2,
      props.shop_cart_text_total_alt3, props.shop_cart_text_order_btn_alt1, props.shop_cart_text_order_btn_alt2,
      props.shop_cart_text_order_btn_alt3, props.shop_cart_text_comment_btn_save_alt1,
      props.shop_cart_text_comment_btn_save_alt2, props.shop_cart_text_comment_btn_save_alt3,
      props.shop_cart_title_modal_alt1, props.shop_cart_title_modal_alt2, props.shop_cart_title_modal_alt3,
      props.shop_cart_success_message_order_alt1, props.shop_cart_success_message_order_alt2,
      props.shop_cart_success_message_order_alt3, props.shop_cart_error_message_order_alt1,
      props.shop_cart_error_message_order_alt2, props.shop_cart_error_message_order_alt3,);
  }

  serialize() {
    return {
      ...super.serialize(),
      use_buttons: this.useButtons,
      use_shopping_cart: this.useShoppingCart,
      use_product_recommendations: this.useProductRecommendations,
      use_initial_recommendations: this.useInitialRecommendations,
      display_currency: this.displayCurrency,
      recommendation_text_alt1: this.recommendationTextAlt1,
      recommendation_text_alt2: this.recommendationTextAlt2,
      recommendation_text_alt3: this.recommendationTextAlt3,
      set_prices_justified_to_right: this.setPricesJustifiedToRight,
      set_border_to_menu: this.setBorderToMenu,
      set_borders_to_subsections: this.setBordersToSubsections,
      default_allergens_status: this.defaultAllergensStatus,
      menu: this.menu,
      use_text_outline: this.useTextOutline,
      use_hyphen_text: this.useHyphenText,
      display_icon_popup: this.displayIconPopup,
      display_product_description: this.displayProductDescription,
      display_branding: this.displayBranding,
      display_social_media: this.displaySocialMedia,
      display_social_media_icons: this.displaySocialMediaIcons,
      display_product_tags: this.displayProductTags,
      display_product_tags_using_icons: this.displayProductTagsUsingIcons,
      use_flags_menu_language_selector: this.useFlagsMenuLanguageSelector,
      use_separator_of_product: this.useSeparatorOfProduct,
      use_icon_in_product_features: this.useIconInProductFeatures,
      use_banner_recommendation: this.useBannerRecommendation,
      branding_image: this.brandingImage,
      footer_text_alt1: this.footerTextAlt1,
      footer_text_alt2: this.footerTextAlt2,
      footer_text_alt3: this.footerTextAlt3,
      shop_text_alt1: this.shopTextAlt1,
      shop_text_alt2: this.shopTextAlt2,
      shop_text_alt3: this.shopTextAlt3,
      shop_text_product_popup_qty_alt1: this.shopTextProductPopupQtyAlt1,
      shop_text_product_popup_qty_alt2: this.shopTextProductPopupQtyAlt2,
      shop_text_product_popup_qty_alt3: this.shopTextProductPopupQtyAlt3,
      shop_text_product_popup_comment_alt1: this.shopTextProductPopupCommentAlt1,
      shop_text_product_popup_comment_alt2: this.shopTextProductPopupCommentAlt2,
      shop_text_product_popup_comment_alt3: this.shopTextProductPopupCommentAlt3,
      shop_text_product_popup_special_text_comment_alt1: this.shopTextProductPopupSpecialTextCommentAlt1,
      shop_text_product_popup_special_text_comment_alt2: this.shopTextProductPopupSpecialTextCommentAlt2,
      shop_text_product_popup_special_text_comment_alt3: this.shopTextProductPopupSpecialTextCommentAlt3,
      shop_text_product_popup_add_btn_alt1: this.shopTextProductPopupAddBtnAlt1,
      shop_text_product_popup_add_btn_alt2: this.shopTextProductPopupAddBtnAlt2,
      shop_text_product_popup_add_btn_alt3: this.shopTextProductPopupAddBtnAlt3,
      shop_cart_text_total_alt1: this.shopCartTextTotalAlt1,
      shop_cart_text_total_alt2: this.shopCartTextTotalAlt2,
      shop_cart_text_total_alt3: this.shopCartTextTotalAlt3,
      shop_cart_text_order_btn_alt1: this.shopCartTextOrderBtnAlt1,
      shop_cart_text_order_btn_alt2: this.shopCartTextOrderBtnAlt2,
      shop_cart_text_order_btn_alt3: this.shopCartTextOrderBtnAlt3,
      shop_cart_text_comment_btn_save_alt1: this.shopCartTextCommentBtnSaveAlt1,
      shop_cart_text_comment_btn_save_alt2: this.shopCartTextCommentBtnSaveAlt2,
      shop_cart_text_comment_btn_save_alt3: this.shopCartTextCommentBtnSaveAlt3,
      shop_cart_title_modal_alt1: this.shopCartTitleModalAlt1,
      shop_cart_title_modal_alt2: this.shopCartTitleModalAlt2,
      shop_cart_title_modal_alt3: this.shopCartTitleModalAlt3,
      shop_cart_success_message_order_alt1: this.shopCartSuccessMessageOrderAlt1,
      shop_cart_success_message_order_alt2: this.shopCartSuccessMessageOrderAlt2,
      shop_cart_success_message_order_alt3: this.shopCartSuccessMessageOrderAlt3,
      shop_cart_error_message_order_alt1: this.shopCartErrorMessageOrderAlt1,
      shop_cart_error_message_order_alt2: this.shopCartErrorMessageOrderAlt2,
      shop_cart_error_message_order_alt3: this.shopCartErrorMessageOrderAlt3,
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('use_shopping_cart', this.useShoppingCart);
    formData.append('use_buttons', this.useButtons);
    formData.append('use_product_recommendations', this.useProductRecommendations);
    formData.append('use_initial_recommendations', this.useInitialRecommendations);
    formData.append('display_currency', this.displayCurrency);
    formData.append('recommendation_text_alt1', this.recommendationTextAlt1);
    formData.append('recommendation_text_alt2', this.recommendationTextAlt2);
    formData.append('recommendation_text_alt3', this.recommendationTextAlt3);
    formData.append('set_prices_justified_to_right', this.setPricesJustifiedToRight);
    formData.append('set_border_to_menu', this.setBorderToMenu);
    formData.append('set_borders_to_subsections', this.setBordersToSubsections);
    formData.append('default_allergens_status', this.defaultAllergensStatus);
    formData.append('menu', this.menu);
    formData.append('use_text_outline', this.useTextOutline);
    formData.append('use_hyphen_text', this.useHyphenText);
    formData.append('display_icon_popup', this.displayIconPopup);
    formData.append('display_product_description', this.displayProductDescription);
    formData.append('display_branding', this.displayBranding);
    formData.append('display_social_media', this.displaySocialMedia);
    formData.append('display_social_media_icons', this.displaySocialMediaIcons);
    formData.append('display_product_tags', this.displayProductTags);
    formData.append('display_product_tags_using_icons', this.displayProductTagsUsingIcons);
    formData.append('use_flags_menu_language_selector', this.useFlagsMenuLanguageSelector);
    formData.append('use_separator_of_product', this.useSeparatorOfProduct);
    formData.append('use_icon_in_product_features', this.useIconInProductFeatures);
    formData.append('use_banner_recommendation', this.useBannerRecommendation);
    formData.append('branding_image', this.brandingImage);
    formData.append('footer_text_alt1', this.footerTextAlt1);
    formData.append('footer_text_alt2', this.footerTextAlt2);
    formData.append('footer_text_alt3', this.footerTextAlt3);
    formData.append('shop_text_alt1', this.shopTextAlt1);
    formData.append('shop_text_alt2', this.shopTextAlt2);
    formData.append('shop_text_alt3', this.shopTextAlt3);
    formData.append('shop_text_product_popup_qty_alt1', this.shopTextProductPopupQtyAlt1);
    formData.append('shop_text_product_popup_qty_alt2', this.shopTextProductPopupQtyAlt2);
    formData.append('shop_text_product_popup_qty_alt3', this.shopTextProductPopupQtyAlt3);
    formData.append('shop_text_product_popup_comment_alt1', this.shopTextProductPopupCommentAlt1);
    formData.append('shop_text_product_popup_comment_alt2', this.shopTextProductPopupCommentAlt2);
    formData.append('shop_text_product_popup_comment_alt3', this.shopTextProductPopupCommentAlt3);
    formData.append('shop_text_product_popup_special_text_comment_alt1', this.shopTextProductPopupSpecialTextCommentAlt1);
    formData.append('shop_text_product_popup_special_text_comment_alt2', this.shopTextProductPopupSpecialTextCommentAlt2);
    formData.append('shop_text_product_popup_special_text_comment_alt3', this.shopTextProductPopupSpecialTextCommentAlt3);
    formData.append('shop_text_product_popup_add_btn_alt1', this.shopTextProductPopupAddBtnAlt1);
    formData.append('shop_text_product_popup_add_btn_alt2', this.shopTextProductPopupAddBtnAlt2);
    formData.append('shop_text_product_popup_add_btn_alt3', this.shopTextProductPopupAddBtnAlt3);
    formData.append('shop_cart_text_total_alt1', this.shopCartTextTotalAlt1);
    formData.append('shop_cart_text_total_alt2', this.shopCartTextTotalAlt2);
    formData.append('shop_cart_text_total_alt3', this.shopCartTextTotalAlt3);
    formData.append('shop_cart_text_order_btn_alt1', this.shopCartTextOrderBtnAlt1);
    formData.append('shop_cart_text_order_btn_alt2', this.shopCartTextOrderBtnAlt2);
    formData.append('shop_cart_text_order_btn_alt3', this.shopCartTextOrderBtnAlt3);
    formData.append('shop_cart_text_comment_btn_save_alt1', this.shopCartTextCommentBtnSaveAlt1);
    formData.append('shop_cart_text_comment_btn_save_alt2', this.shopCartTextCommentBtnSaveAlt2);
    formData.append('shop_cart_text_comment_btn_save_alt3', this.shopCartTextCommentBtnSaveAlt3);
    formData.append('shop_cart_title_modal_alt1', this.shopCartTitleModalAlt1);
    formData.append('shop_cart_title_modal_alt2', this.shopCartTitleModalAlt2);
    formData.append('shop_cart_title_modal_alt3', this.shopCartTitleModalAlt3);
    formData.append('shop_cart_success_message_order_alt1', this.shopCartSuccessMessageOrderAlt1);
    formData.append('shop_cart_success_message_order_alt2', this.shopCartSuccessMessageOrderAlt2);
    formData.append('shop_cart_success_message_order_alt3', this.shopCartSuccessMessageOrderAlt3);
    formData.append('shop_cart_error_message_order_alt1', this.shopCartErrorMessageOrderAlt1);
    formData.append('shop_cart_error_message_order_alt2', this.shopCartErrorMessageOrderAlt2);
    formData.append('shop_cart_error_message_order_alt3', this.shopCartErrorMessageOrderAlt3);

    if (this.brandingImage instanceof File) {
      if (this.brandingImage.size !== 0) {
        formData.append('branding_image', this.brandingImage, this.brandingImage.name);
      }
    } else if (!this.brandingImage) {
      formData.append('branding_image', '');
    }

    return formData;
  }

  get recommendationText() {
    return this.recommendationTextAlt1;
  }
}
